export const environment = {
  production: false,
  api_url: 'https://backend-test.kuru.com.br/v1'
}